/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { renditionsControllerFindAll } from "./renditionsControllerFindAll";
import { renditionsControllerFindOne } from "./renditionsControllerFindOne";

export function documentRenditionsService() {
  return { renditionsControllerFindAll, renditionsControllerFindOne }
}